import styled from 'styled-components';

export const Container = styled.span({
  fontSize: '13rem',
});
